import { Fragment } from "react";
import { FaFacebook } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoCall, IoMail, IoLocation } from "react-icons/io5";
import { PiTrafficConeFill } from "react-icons/pi";

function Footer() {
	const socialLinks = [
		{
			href: "https://www.facebook.com/steersmartdrivingschool",
			icon: FaFacebook,
			name: "Facebook",
		},
		// { href: "https://twitter.com", icon: FaTwitter },
		// { href: "https://instagram.com", icon: FaInstagram },
	];

	const footerLinks = [
		{ name: "About", to: "/about" },
		{ name: "Packages", to: "/packages" },
		{ name: "Contact", to: "/contact" },
		{ name: "Blogs", to: "/articles" },
	];

	return (
		<div className="py-6 lg:py-6 text-steerBlack bg-white/60 backdrop-blur-md flex flex-col gap-6 md:gap-20 rounded-t-2xl md:rounded-2xl px-6 md:px-12">
			<div className="md:flex hidden justify-between items-center gap-2">
				{footerLinks.map((link, index) => (
					<Fragment key={index}>
						<Link
							to={link.to}
							className="hover:scale-105 duration-300 ease-in transition-transform text-base md:text-2xl font-bold uppercase cursor-pointer"
						>
							{link.name}
						</Link>
						{index < footerLinks.length - 1 && (
							<PiTrafficConeFill className="hidden md:flex text-4xl text-steerOrange" />
						)}
					</Fragment>
				))}
			</div>

			<div className="flex flex-col md:flex-row justify-center md:justify-between items-center md:items-end gap-6">
				<div className="flex items-center">
					{/* <img
						src="/images/logo-transparentbg-orange.webp"
						alt="Logo"
						className="xl:lg:w-32 w-72"
					/> */}
					<h2 className="text-8xl md:text-9xl font-black tracking-tight text-steerOrange text-center">
						STEER
						<br className="flex md:hidden" />
						SMART
					</h2>
				</div>

				<div className="md:hidden flex justify-between items-center gap-4">
					{footerLinks.map((link, index) => (
						<Fragment key={index}>
							<Link
								to={link.to}
								className="hover:scale-105 duration-300 ease-in transition-transform text-base md:text-2xl font-bold uppercase cursor-pointer"
							>
								{link.name}
							</Link>
							{index < footerLinks.length - 1 && (
								<PiTrafficConeFill className="hidden md:flex text-4xl text-steerOrange" />
							)}
						</Fragment>
					))}
				</div>

				<div className="flex flex-col gap-4">
					<div className="flex flex-col gap-4">
						<a
							href="tel:+61450487804"
							className="flex gap-4 items-center group font-bold cursor-pointer"
						>
							<IoCall className="text-lg" />
							<span className="transform transition-transform duration-300 ease-in group-hover:-translate-x-2 text-sm">
								+61 450 487 804
							</span>
						</a>

						<a
							href="mailto:info@steersmartdriving.com.au"
							className="flex gap-4 items-center group font-bold cursor-pointer"
						>
							<IoMail className="text-lg" />
							<span className="transform transition-transform duration-300 ease-in group-hover:-translate-x-2 text-sm">
								info@steersmartdriving.com.au
							</span>
						</a>

						<div className="flex gap-4 items-center">
							<IoLocation className="text-lg" />
							<p className="text-sm">ACT & Queanbeyan</p>
						</div>
					</div>

					<div className="flex gap-4 justify-center md:justify-normal pb-12 md:pb-0">
						{socialLinks.map((link, index) => {
							{
								/* const IconComponent = link.icon; */
							}
							return (
								<a
									key={index}
									href={link.href}
									className="hover:scale-105 duration-300 text-steerOrange ease-in transition-transform text-lg uppercase font-bold"
								>
									{link.name}
								</a>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
}

export default Footer;
